import routes from "@/routers/routes";
import { fetchPartnerById } from "@/server/api-services";
import { Partner } from "@/types";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PageHeader from "../page-header";
import CreateEditPartner from "@/app/shared/settings/partners/create-edit";


export default function EditPartnerPage() {
    const { Id } = useParams();

    const [service, setPartner] = useState({} as Partner);

    const pageHeader = {
        title: "Create Partner",
        breadcrumb: [
            {
                href: routes.settings.partners.list,
                name: "home",
            },
            {
                name: "Add New Partner",
            },
        ],
    };

    useEffect(() => {
        getPartner();
    }, []);

    const getPartner = async () => {
        const response = await fetchPartnerById(Id as string);

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Partner;

        setPartner(data);
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                hideButton={true}
            ></PageHeader>

            <CreateEditPartner id="" isEdit={true} partner={service} />
        </>
    );
}
